import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom'

export function ErrorBoundary() {
  const error = useRouteError()

  let errorMessage: string
  let errorStatus: number | undefined

  if (isRouteErrorResponse(error)) {
    errorMessage = error.statusText || error.data
    errorStatus = error.status
  } else if (error instanceof Error) {
    errorMessage = error.message
  } else {
    errorMessage = 'Unknown error occurred'
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: '32rem' }}>
        {errorStatus && (
          <h1 style={{ fontSize: '6rem', fontWeight: 'bold', margin: 0, color: '#ef4444' }}>
            {errorStatus}
          </h1>
        )}
        <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginTop: '1rem' }}>
          Oops! Something went wrong
        </h2>
        <p style={{ marginTop: '1rem', color: '#6b7280' }}>{errorMessage}</p>
        <Link
          to="/"
          style={{
            display: 'inline-block',
            marginTop: '2rem',
            padding: '0.75rem 1.5rem',
            backgroundColor: '#2563eb',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '0.375rem',
            fontWeight: '500',
          }}
        >
          Go back home
        </Link>
      </div>
    </div>
  )
}
